var exports = {
  "q7": "Item__7jAFYw",
  "ss": "current__3SuIGX",
  "N_": "Link__OiaOCs",
  "Jc": "LeadingVisual__aDSWvn",
  "BG": "TrailingVisual__U70gdx",
  "Qg": "visuallyHidden__LK-mol",
};

module.exports = exports;
